module.exports = __webpack_public_path__ + "img/JE.c6b94112.png";